import { decodeAny } from "./decodeAny";
import { decodeNumber } from "./decodeNumber";
import { EncodableValue } from "./types";

export function decodeMixedArray(
  data: Uint8Array,
  offset = 0,
): [EncodableValue[], number] {
  // Pass offset directly instead of slicing — slice allocates a copy for every call.
  const [length, lengthBytes] = decodeNumber(data, offset + 1);
  const result: EncodableValue[] = [];
  let currentOffset = offset + 1 + lengthBytes;

  for (let i = 0; i < length; i++) {
    const [value, bytesConsumed] = decodeAny(data, currentOffset);

    result.push(value);
    currentOffset += bytesConsumed;
  }

  return [result, currentOffset - offset];
}
